import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function ShowMonthNavSkeleton() {
  return (
    <div className="flex shrink-0 items-center justify-between border-b border-border px-3 py-1.5">
      <div className="flex items-center gap-2">
        <Skeleton className="size-6 rounded-md" />
        <Skeleton className="h-[18px] w-[130px]" />
        <Skeleton className="size-6 rounded-md" />
      </div>
      <Skeleton className="h-6 w-16 rounded-md" />
    </div>
  );
}
